var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlacktime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_2675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.93164 13.2188C3.93164 14.4669 4.17747 15.7028 4.65509 16.8559C5.13271 18.0089 5.83277 19.0567 6.7153 19.9392C7.59783 20.8217 8.64554 21.5218 9.79862 21.9994C10.9517 22.477 12.1876 22.7228 13.4356 22.7228C14.6837 22.7228 15.9196 22.477 17.0727 21.9994C18.2257 21.5218 19.2735 20.8217 20.156 19.9392C21.0385 19.0567 21.7386 18.0089 22.2162 16.8559C22.6938 15.7028 22.9396 14.4669 22.9396 13.2188C22.9396 11.9708 22.6938 10.7349 22.2162 9.58182C21.7386 8.42874 21.0385 7.38103 20.156 6.4985C19.2735 5.61597 18.2257 4.91591 17.0727 4.43829C15.9196 3.96067 14.6837 3.71484 13.4356 3.71484C12.1876 3.71484 10.9517 3.96067 9.79862 4.43829C8.64554 4.91591 7.59783 5.61597 6.7153 6.4985C5.83277 7.38103 5.13271 8.42874 4.65509 9.58182C4.17747 10.7349 3.93164 11.9708 3.93164 13.2188Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4355 13.2188L16.6035 15.3307",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4355 7.93945V13.2195",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.344,
    height: 25.344,
    fill: "white",
    transform: "translate(0.763672 0.546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacktime);
export default __webpack_public_path__ + "static/media/blacktime.4e187418a538f3f954408fc43c5f8442.svg";
export { ForwardRef as ReactComponent };